<template>
  <div class="toast-container">
    <transition-group name="toast">
      <div 
        v-for="toast in toasts" 
        :key="toast.id" 
        class="toast" 
        :class="[`toast-${toast.type}`]"
        @click="removeToast(toast.id)"
      >
        <div class="toast-icon">
          <i v-if="toast.type === 'success'" class="fas fa-check"></i>
          <i v-else-if="toast.type === 'error'" class="fas fa-times"></i>
          <i v-else-if="toast.type === 'warning'" class="fas fa-exclamation"></i>
          <i v-else class="fas fa-info"></i>
        </div>
        <span class="toast-message">{{ toast.message }}</span>
      </div>
    </transition-group>
  </div>
</template>

<script>
import { mapState } from 'pinia';
import { useToastStore } from '@/stores/toast';

export default {
  name: 'ToastContainer',
  computed: {
    // Compatível com Vue 2 e Vue 3
    ...mapState(useToastStore, ['toasts'])
  },
  methods: {
    removeToast(id) {
      const toastStore = useToastStore();
      toastStore.removeToast(id);
    }
  }
};
</script>

<style scoped>
.toast-container {
  position: fixed;
  bottom: 16px;
  right: 16px;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 320px;
}

.toast {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  transition: all 0.3s ease;
  gap: 12px;
}

.toast-success {
  background-color:#d4edda ; /* verde pastel mais suave #d4edda   #d1fae5*/
  color: #155724; /* texto verde escuro mais suave #155724 #047857*/
}

.toast-error {
  background-color: #f8d7da; /* vermelho pastel mais suave  #fee2e2*/
  color: #721c24; /* texto vermelho escuro mais suave #721c24 #b91c1c*/
}

.toast-warning {
  background-color:#fff3cd ; /* amarelo pastel mais suave #fff3cd #ffedd5*/
  color:#856404 ; /* texto laranja escuro mais suave #856404 #c2410c*/
}

.toast-info {
  background-color: #cce5ff; /* azul pastel mais suave #cce5ff #dbeafe*/
  color: #004085; /* texto azul escuro #004085  #1e40af*/
}

.toast-icon {
  flex-shrink: 0;
}

.toast-message {
  font-size: 16px;
  font-weight: 400;
  flex: 1;
}

/* Animation */
.toast-enter-active,
.toast-leave-active {
  transition: all 0.3s;
}

.toast-enter-from,
.toast-enter {
  transform: translateX(100%);
  opacity: 0;
}

.toast-leave-to {
  transform: translateY(30px);
  opacity: 0;
}
</style>